import React, { useState, Fragment } from "react"
import { observer } from "mobx-react"

import styles from "./styles"

import { Stack } from "@mui/material"
import { Table } from "../../components"
import { TableEntry } from "./components"

const DynamicTable = (props) => {
	const [reactTableProps, setReactTableProps] = useState(() => ({}))

	props.config.exposeReactTableProps = ({ props }) => setReactTableProps(props)

	const mobileConfig = props?.mobileConfig || {}
	const mobileOnly = mobileConfig?.mobileOnly

	const entries = reactTableProps?.data || []
	const updateEntries = reactTableProps?.updateData

	const columns = { ...props }.Header.filter((column) => !column.mobileOnly)
	const rows = { ...props }.Header

	return (
		<Fragment>
			<Stack sx={styles.desktopContainer(mobileOnly)}>
				<Table {...{ ...props, Header: columns }} />
			</Stack>

			<Stack spacing="25px" sx={styles.mobileContainer(mobileOnly)}>
				{Array.from(entries?.values())?.map((entry) => (
					<TableEntry
						key={entry?.id}
						entries={entries}
						updateEntries={updateEntries}
						entry={entry}
						rows={rows}
						mobileConfig={mobileConfig}
					/>
				))}
			</Stack>
		</Fragment>
	)
}

export default observer(DynamicTable)
